import React from 'react';
import { Plate, Title } from '../MainPageStyled';
import { Link } from 'react-router-dom';
import { useClickStreamContext } from 'features/shared/ClickStream';

export const PlateTemplate = (
  props: React.PropsWithChildren<{ title: string; link: string; name: string; style?: React.CSSProperties; dataQaId?: string }>,
) => {
  const { logPageEvent } = useClickStreamContext();
  return (
    <Plate
      onClick={() => {
        logPageEvent({
          eventInfo: 'Главная страница клик по ' + props.name,
          eventType: 'main_page_click_on_' + props.name,
        });
        window.scrollTo({ top: 0 });
      }}
      data-qa-id={props.dataQaId}
      as={Link}
      to={props.link}
      style={props.style}
    >
      <Title>{props.title}</Title>
      {props.children}
    </Plate>
  );
};
